import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getUserDetails = createAsyncThunk(
  "master/getUserDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.USER_DETAILS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const userSlice = createSlice({
  name: "getUserDetails",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default userSlice.reducer;
